import { render } from "./ViewList.vue?vue&type=template&id=d97ba7d2"
import script from "./ViewList.vue?vue&type=script&lang=js"
export * from "./ViewList.vue?vue&type=script&lang=js"
script.render = render

export default script